exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-screenshare-plugin,#asseco-screenshare .asseco-floaty-btn{background-color:#0288d1}#asseco-screenshare-plugin.is-active,#asseco-screenshare.is-active{animation:screenshare-blink 1s infinite}@keyframes screenshare-blink{0%{opacity:1}to{opacity:0}}", ""]);

// exports
